module.exports = __webpack_public_path__ + "img/744.92863092.jpg";